const DpoCorePredvyplnenaZadost = {
    init: function () {
        const tlacitko = $("#tlacitkoPredvyplnitZadost");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }
                tlacitko.attr("disabled", true).prop("disabled", true);

                let url = window.location.protocol + "//" + window.location.host;
                url += "/ajax/core/predvyplnitZadost";

                const sekceId = $('#idSection').val();
                if (!sekceId) {
                    return;
                }
                url += '/' + sekceId;

                const titulId = $('#idItem').val();
                if (!titulId) {
                    return;
                }
                url += '/' + titulId;

                $.ajax({
                    type: "get",
                    url: url,
                    dataType: "json",
                    global: true,
                    beforeSend: function () {
                        Lemo_Alert.closeAll();
                    },
                    success: function (r) {
                        if (r.hasOwnProperty("messages")) {
                            Lemo_Alert.addMany(r["messages"]);
                        }

                        if (r.hasOwnProperty("data")) {
                            let url = window.location.protocol + "//" + window.location.host;
                            url += '/section/zadosti/item/edit/' + r["data"]["id"];
                            window.location = url;
                        }
                    },
                    complete: function () {
                        tlacitko.attr("disabled", false).prop("disabled", false);
                    },
                    error: function () {
                        Lemo_Alert.addDanger("Předvyplnění žádosti selhalo.", "predvyplneniZadostiError");
                    }
                });
            });
    },

    initVyraditZadost: function () {
        const tlacitko = $("#tlacitkoVyraditZadost");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                tlacitko.attr("disabled", true).prop("disabled", true);

                let url = window.location.protocol + "//" + window.location.host;
                url += "/ajax/core/vyraditZadost";

                const sekceId = $('#idSection').val();
                if (!sekceId) {
                    return;
                }
                url += '/' + sekceId;

                const zadostId = $('#idItem').val();
                if (zadostId) {
                    url += '/' + zadostId;
                }

                const _ch = $("#_ch");
                if (!_ch.length) {
                    return;
                }

                $.ajax({
                    type: "post",
                    url: url,
                    data: {"_ch": _ch.val()},
                    dataType: "json",
                    global: true,
                    beforeSend: function () {
                        Lemo_Alert.closeAll();
                    },
                    complete: function () {
                        tlacitko.attr("disabled", false).prop("disabled", false);
                    },
                    success: function (r) {
                        if (r.hasOwnProperty("messages")) {
                            Lemo_Alert.addMany(r["messages"]);
                        }
                        window.location.reload();
                    }
                });
            });
    }
}

$(document).ready(function () {
    DpoCorePredvyplnenaZadost.init();
    DpoCorePredvyplnenaZadost.initVyraditZadost();
});